import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    data: null,
    isFetching: false,
    isError: false
};
var getAllGroupOfSupplierSlice = createSlice({
    name: "getAllGroupOfSupplier",
    initialState: initialState,
    reducers: {
        fetchData: function(state) {
            state.isFetching = true;
            state.data = null;
            state.isError = false;
        },
        fetchDataSuccess: function(state, action) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                data: action.payload
            });
        },
        fetchDataFailure: function(state) {
            return _object_spread_props(_object_spread({}, state), {
                isFetching: false,
                isError: true
            });
        },
        resetState: function() {
            return initialState;
        }
    }
});
var _getAllGroupOfSupplierSlice_actions = getAllGroupOfSupplierSlice.actions;
export var fetchData = _getAllGroupOfSupplierSlice_actions.fetchData, fetchDataSuccess = _getAllGroupOfSupplierSlice_actions.fetchDataSuccess, fetchDataFailure = _getAllGroupOfSupplierSlice_actions.fetchDataFailure, resetState = _getAllGroupOfSupplierSlice_actions.resetState;
export default getAllGroupOfSupplierSlice.reducer;
